import React, { Component } from 'react';

import { ListItem } from 'material-ui/List';

import LinearProgress from 'material-ui/LinearProgress';
import Gravatar from 'react-gravatar';

import { sanitise } from '../../stores/UserStore';

import { formatName } from '../../utils/StringUtils';

class ProfileListItem extends Component {


    render () {

        const row = sanitise(this.props.data);
        const infoLink = `/dashboard/profile/${row.userId}`;

        const style = {

            iconButton: {
                marginRight: 0,
            },
            listItem: {
                padding: '2px',
            },
            avatar: {
                borderRadius: '50%',
                marginRight: '16px',
            },
        };

        const description = row.email || '';

        let listItemProps = {
            key: row.id,
            style: style.listItem,

        };

        let flags = [];
        if ((!!row.role) && (row.role !== '')) {

            if (row.isAdmin) {
                flags.push(<span key="a" className="flag-text">admin</span>);
            }

            if (row.isManager) {
                flags.push(<span key="m" className="flag-text">manager</span>);
            }
        }

        listItemProps.primaryText = (
            <div className="primaryText">
                {formatName(row)}
            </div>
        );

        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else {
            listItemProps.secondaryText = (
                <div className="secondaryText">
                    {flags}{description}
                </div>
            );
            listItemProps.secondaryTextLines = 2;
        }

        return (

            <ListItem {...listItemProps}
                leftAvatar={
                        <Gravatar
                            email={row.email}
                            default='https://cdn.premierit.com/images/icons/contact.png'
                            size={50}
                            style={style.avatar}
                        />

                }
            />
        )
    }
}



export default ProfileListItem;
